// ============================================================================
// Единое место для всех текстов, числа страниц и обложек лид-магнита.
// Используется и обычным блоком LeadMagnetBlock, и хиро-тизером.
// ============================================================================
export const PAGES_COUNT = 23;

export const IMAGE_ALT =
  'Обложка пособия «Система развития отдела продаж», 23 страницы';

type YandexMetrica = (id: number, action: string, goal?: string) => void;

// Единая точка отправки цели в Яндекс.Метрику для лид-магнита.
export function reachGoal(goal: string) {
  const w = window as unknown as { ym?: YandexMetrica };
  if (w.ym) {
    w.ym(106079874, 'reachGoal', goal);
  }
}

export const CONTENT = {
  full: {
    heading: 'Тренинг раз в год не работает. Что работает вместо него?',
    subtitle: `Пособие на ${PAGES_COUNT} страницы: как выстроить в отделе продаж систему развития, которая держится не на энтузиасте РОПа, а на понятном календаре.`,
    listTitle: 'Внутри',
    list: [
      'три уровня сотрудников (Junior, Middle, Senior) и что делать с «забытыми середнячками»;',
      'план адаптации новичка на первые 3 месяца по неделям;',
      '7 методов регулярного развития, которые не требуют тренера каждый раз;',
      'готовые шаблоны: годовой, квартальный и недельный план;',
      'как понять, что обучение сработало, и чек-листы, которые можно распечатать.',
    ],
    afterList:
      'Выжимка из моей практики с отделами продаж и из вебинара. Без воды: примеры, таблицы и шаблоны, которые можно адаптировать под свою команду за час.',
    image: {
      mobile: {
        src: 'https://storage.helloreaddy.io/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/17b8f6a5-2fca-4069-8524-f7c702df1553_compressed_posobie-site-1600x1200.webp',
        width: 1600,
        height: 1200,
      },
      desktop: {
        src: 'https://storage.helloreaddy.io/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/58413a5b-d529-4933-8e46-c106d397626a_compressed_posobie-stories-1080x1920.webp',
        width: 1080,
        height: 1920,
      },
    },
  },
  compact: {
    text: `Хотите, чтобы развитие команды не зависело от настроения РОПа? Пособие на ${PAGES_COUNT} страницы: уровни сотрудников, адаптация по неделям, шаблоны планов.`,
    button: 'Получить PDF-пособие',
    modalTitle: 'Пособие на почту',
    image: {
      src: 'https://storage.helloreaddy.io/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/ce2c872d-ff43-4039-ac70-76637f7394fb_compressed_posobie-social-1080x1080.webp',
      width: 1080,
      height: 1080,
    },
  },
  // Тизер в хиро-секции: только текст кнопки, картинка и заголовок модалки
  // берутся из compact, чтобы не плодить дубли.
  teaser: {
    button: 'PDF: как развивать отдел продаж системно',
  },
} as const;